import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxiosWithToken } from "./createAxios";

export async function Dashboard(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/Dashboard?FromDate=" + param.fromDate + "&ToDate=" + param.toDate + "&CenterId=" + param.centerId + "&IsCenter=" + param.isCenter)
}
export async function DailyReport(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/DailyCenter?CenterId=" + param.centerId)
}

//New Features
export async function ForDateCenter(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/ForDateCenter?CenterId=" + param.centerId +"&ForDate=" + param.ForDate)
}